import React, { useState, useEffect} from 'react'
import queryString from 'query-string';
import axios from 'axios';
import {withRouter} from 'react-router-dom';
import {Player, ControlBar} from 'video-react';
import ReactPlayer from 'react-player';
import { Layout } from 'antd';
import { PageHeader } from 'antd';
import myHeader from '../../Components/CourseHeader/Header';
import MainContent from '../../Components/CourseMainContent/MainContent';
import logo from '../../Assests/assets/images/layer-1.png';
const { Header, Footer, Content } = Layout;
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
const CoursePage = (props)=>{
  let [user, setUser] = useState({});
  let [isValidated, setIsValidated] = useState(false);
  let [isPlayingVideo, setIsPlayingVideo] = useState(true);
  let [isLoggedIn, setIsLoggedIn] = useState(false);
  let url = props.location.search;
  let params = queryString.parse(url);
  console.log(params);
  console.log(params.token);
  var token;
  
  /* If no token is passed, check if localStorage has the token. */
  /*
  useEffect(() => {
    if(isEmpty(params)) {
      token = localStorage.getItem('glossaread-token');
    } else {
      token = params.token;
      localStorage.setItem('glossaread-token', params.token);
      props.history.push('/course');
    }
    console.log(token);
    var reqData = {
      token: token
    };
    console.log(reqData);
    if(token) {
      console.log('making request to get data');
      //axios.get('http://13.234.61.196:2222/react-login', {
      axios.get('http://13.234.61.196:2222/react-login', {
        params: reqData
      })
      .then((res) => {
        console.log(res);
        setUser(res.data);
        setIsValidated(true);
      })
      .catch((err) => {
        console.log(err);
      });
    } else {
      console.log('no token found');
    }
  }, [params.token]);
  */

  /* If a token is being passed, get the token, request a JWT
   * for the token, and save the received JWT. */
  useEffect(() => {
    if(!isEmpty(params)) {
      token = params.token;
      var reqData = {
        token: token,
        deviceId: 2
      };
      axios.get('https://7635fb0202f3.ngrok.io/react-login', {
        params: reqData
      })
      .then((res) => {
        console.log(res);
        //Add JWT received to local-storage
        localStorage.setItem('glossaread-token', res.data.st);
        props.history.push('/course');
      })
      .catch((err) => {
        console.log(err);
      });
    } else {
      console.log("using JWT");
      //make Request to get the courseData
    }
  }, [params.token]);

  useEffect(() => {
    if(!localStorage.getItem('glossaread-token')) {
      return;
    }
    setIsLoggedIn(true);
    return;
    var reqData = {
      token: localStorage.getItem('glossaread-token')
    };
    
    // Get course-data
    axios.get('https://7635fb0202f3.ngrok.io/react-login', {
      params: reqData
    })
    .then((res) => {
      console.log(res);
      //Set the response received
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);

  return (
    <Layout>
      {/*
      <Header className="site-page-header">
        <p class='header-img-container'>
          <img src={logo} class='header-img'/> 
        </p>
      </Header>
      */}
      <Content class="site-page-content">
        <MainContent isLoggedIn={isLoggedIn}/>
      </Content>
      <Footer className='site-page-footer'>
        <div class='footer-text'>
          Copyright © 2020. All right reserved.
        </div>
      </Footer>
    </Layout>
  )
}
export default withRouter(CoursePage); 
